import React from 'react'
import { Box } from '@mui/material'
import { usModelOfAtomsChecker } from 'src/logic'

type Props = {
  productNumber: string
}

export const UsModelCaution: React.FC<Props> = ({ productNumber }) => {
  if (!usModelOfAtomsChecker(productNumber)) return <></>
  return (
    <Box pb={2}>
      <Box px={2} color={'red'}>
        ※USモデルは日本国内でのオーダーは対応しておりません。日本国外（韓国・中国）からのみオーダー可能です。ご不明な点があれば、各国の販売代理店へお問い合わせください。
      </Box>
      <Box px={2} color={'red'}>
        ※ US 모델은 일본에서는 주문이 불가능합니다. 일본 외 지역(한국, 중국)에서만 주문 가능합니다. 궁금한 점이 있으시면 각국의 판매 대리점에 문의해
        주시기 바랍니다.
      </Box>
      <Box px={2} color={'red'}>
        ※美国机型无法在日本订购，仅限日本国外（韩国、中国）的客户订购。如有疑问，请联系各国的销售代理商。
      </Box>
      <Box px={2} color={'red'}>
        ※US models are not available for order in Japan and can only be ordered from outside Japan (Korea and China). If you have any questions,
        please contact the sales representatives in each country.
      </Box>
    </Box>
  )
}
